import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import Loading from '@justgiving/loading';
import Alert from '@justgiving/alert';
import { createErrorKey } from 'utils';
import { renderField } from 'utils/FormUtils';
import FormError from 'components/Alert/FormError';
import { Trans } from 'react-i18next';

class EmailForm extends Component {
  static propTypes = {
    fetchData: PropTypes.func.isRequired,
    trackPageView: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    resetAppErrors: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    status: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      fetchError: PropTypes.bool.isRequired,
      postError: PropTypes.bool.isRequired,
      errorMessage: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    submitting: false,
    submitSucceeded: false,
    error: false,
  };

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { fetchData, trackPageView } = this.props;
    fetchData();
    trackPageView('email', 'personal details > email');
  }

  componentWillUnmount() {
    this.props.reset();
    this.props.resetAppErrors();
  }

  onSubmit(values) {
    const { trackLinkClick, submitHandler } = this.props;
    trackLinkClick('button', 'personal details > email', 'save');
    return submitHandler(values);
  }

  render() {
    const {
      status,
      handleSubmit,
      submitSucceeded,
      submitting,
      error,
    } = this.props;

    if (status.isFetching) {
      return <Loading size="large" colour="purple" />;
    }

    const errorKey = createErrorKey(status.errorMessage);

    return (
      <form
        method="POST"
        className="jg-space-mtmd"
        onSubmit={handleSubmit(this.onSubmit)}
      >
        {(status.errorMessage || error) && <FormError apiError={errorKey} />}
        {submitSucceeded && !status.errorMessage && (
          <Alert type="success" className="qa-message__success jg-space-mbmd">
            <Trans i18nKey="emailForm.emailUpdated">
              Your email has been updated
            </Trans>
          </Alert>
        )}
        <div className="jg-form-group">
          <label htmlFor="EmailAddress" className="jg-form-label form-row">
            <Trans i18nKey="personalDetails.email">Email address</Trans>
            <Field
              name="EmailAddress"
              disabled={status.fetchError}
              component={renderField}
              type="email"
              label="Email Address"
              autoComplete="email"
              maxlength="100"
            />
          </label>
          {submitting ? (
            <button type="submit" className="jg-btn jg-btn--brand" disabled>
              <Loading size="small" colour="white" />
            </button>
          ) : (
            <button
              type="submit"
              className="jg-btn jg-btn--brand qa-button__submit"
              disabled={status.fetchError}
            >
              <Trans i18nKey="personalDetails.save">Save</Trans>
            </button>
          )}
        </div>
      </form>
    );
  }
}

export default EmailForm;
